import React from "react";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CardHeaderProps } from "../types";

function CardHeader({ className, ...props }: CardHeaderProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Flex
      data-slot="card-header"
      fill
      direction="column"
      justify="start"
      items="center"
      className={cn(className, classes)}
      {...native}
    />
  );
}

CardHeader.displayName = "Card.Header";

export default CardHeader;
